import React from "react"
import PropTypes from "prop-types"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import ListSubheader from "@mui/material/ListSubheader"
import { ref, get } from "firebase/database"

import { sdk9db } from "../../firebase"
import { STATE_NAME_MAPPING } from "../../content"
import { getInstructorFullNameLookup } from "../../utils/instructorUtils"

class InstructorSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      instructors: null,
      selectedInstructorId: props.selectedInstructorId
        ? props.selectedInstructorId
        : "",
      instructorStateMapping: null,
      instructorFullNameLookup: null,
    }
  }

  componentDidMount() {
    getInstructorFullNameLookup().then((result) =>
      this.setState({ instructorFullNameLookup: result }),
    )

    get(ref(sdk9db, "instructors")).then((instructorsSnap) => {
      const instructors = {}
      const instructorStateMapping = {}
      instructorsSnap.forEach((instructorSnap) => {
        const instructor = instructorSnap.val()
        if (
          !instructor.isRetired &&
          !instructor.isTrainee &&
          (this.props.doShowInactiveInstructors || !instructor.isInactive)
        ) {
          instructor.id = instructorSnap.key
          const instructorState = instructor.state || "CA"
          if (!(instructorState in instructors)) {
            instructors[instructorState] = []
          }
          instructors[instructorState].push(instructor)
          instructorStateMapping[instructor.id] = instructorState
        }
      })
      // This is an ugly mutation.
      Object.keys(instructors).map((key) =>
        instructors[key].sort((a, b) =>
          a.displayName.localeCompare(b.displayName),
        ),
      )
      this.setState({ instructors, instructorStateMapping })
    })
  }

  handleSelectChange = (e) => {
    this.setState({ selectedInstructorId: e.target.value })
    const { instructorStateMapping, instructors } = this.state
    const incomingInstructorId = e.target.value
    // Return the instructor object.
    const instructor = instructors[
      instructorStateMapping[incomingInstructorId]
    ].filter((inst) => inst.id === incomingInstructorId)
    if (instructor.length > 0) {
      this.props.onChangeCallback(instructor[0])
    } else {
      this.props.onChangeCallback(null)
    }
  }

  render() {
    const { instructors, selectedInstructorId, instructorFullNameLookup } =
      this.state
    const { disabled } = this.props

    if (!instructors || !instructorFullNameLookup) {
      return null
    }

    return (
      <TextField
        select
        name="instructor"
        label="Instructor"
        value={selectedInstructorId}
        onChange={this.handleSelectChange}
        margin="normal"
        data-cy="instructor-select"
        fullWidth
        disabled={disabled}
        helperText={disabled && "This field cannot be edited."}
      >
        {Object.keys(instructors).map((instructorState) => [
          <ListSubheader key={instructorState}>
            {STATE_NAME_MAPPING[instructorState]}
          </ListSubheader>,
          instructors[instructorState].map((inst) => (
            <MenuItem
              value={inst.id}
              key={inst.id}
              data-cy="instructor-select-item"
            >
              {inst.isInactive
                ? `${instructorFullNameLookup[inst.id]} (Inactive)`
                : instructorFullNameLookup[inst.id]}
            </MenuItem>
          )),
        ])}
      </TextField>
    )
  }
}

InstructorSelect.propTypes = {
  onChangeCallback: PropTypes.func.isRequired,
  selectedInstructorId: PropTypes.string,
  disabled: PropTypes.bool,
  doShowInactiveInstructors: PropTypes.bool,
}

InstructorSelect.defaultProps = {
  selectedInstructorId: null,
  disabled: false,
  doShowInactiveInstructors: false,
}

export default InstructorSelect
